import {
	POST_INCIDENCES,
	POST_INCIDENCES_ERROR,
	POST_INCIDENCES_ERROR_SHOW,
	POST_INCIDENCES_SUCCESS,
} from './../../constants';

export const postIncidencesReducer = (state, actions) => {
	switch (actions.type) {
		case POST_INCIDENCES:
			return {
				...state,
				loading: true,
			};
		case POST_INCIDENCES_ERROR:
			return {
				incidences: state.incidences,
				//	collaboratorsOptions: state.collaboratorsOptions,
				loading: false,
				error: actions.payload,
				errorShow: false,
			};
		case POST_INCIDENCES_SUCCESS:
			return {
				incidences: actions.payload,
				//collaboratorsOptions: getCollaboratorOptions(actions.payload),
				loading: false,
				error: null,
				errorShow: false,
			};
		case POST_INCIDENCES_ERROR_SHOW:
			return {
				...state,
				errorShow: true,
			};
		default:
			return state;
	}
};
